import Button from '@material-ui/core/Button';

const SubmitButton = ({ children, disabled, onClick }) => (
  <Button color="primary" disabled={ disabled } onClick={ onClick }>
    {children}
  </Button>
);

export default SubmitButton;
